// Schema-facing attorney list (E-E-A-T). Data in attorneys.json so the Node
// build scripts and the React app share one source. Names mirror the Team page.
import ATTORNEYS_DATA from './attorneys.json';

export const ATTORNEYS = ATTORNEYS_DATA;
